import { createSlice } from "@reduxjs/toolkit";

const readOnlySlice = createSlice({
  name: "readOnly",
  initialState: {
    isReadOnly: false,
  },
  reducers: {
    setReadOnly: (state, action) => {
      state.isReadOnly = action.payload;
    },
  },
});

export const { setReadOnly } = readOnlySlice.actions; // Ensure this is exported
export default readOnlySlice.reducer; // Ensure the reducer is exported
